import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 22"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { "clip-path": "url(#a)" }, [
  /*#__PURE__*/_createElementVNode("path", { d: "m5.826 18.74-2.3 2.3q-.475.474-1.087.212-.613-.263-.613-.938V4.74q0-.825.588-1.412a1.93 1.93 0 0 1 1.412-.588h16q.825 0 1.413.588.587.587.587 1.412v12a1.93 1.93 0 0 1-.587 1.413 1.93 1.93 0 0 1-1.413.587zm-.85-2h14.85v-12h-16v13.124l1.15-1.125Z" })
], -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("defs", null, [
  /*#__PURE__*/_createElementVNode("clipPath", { id: "a" }, [
    /*#__PURE__*/_createElementVNode("path", { d: "M0 .74h24v20.522H0z" })
  ])
], -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_4]))
}
export default { render: render }